import { render, staticRenderFns } from "./AssistanceProtocolTable.vue?vue&type=template&id=10aac2eb&scoped=true&"
import script from "./AssistanceProtocolTable.vue?vue&type=script&lang=js&"
export * from "./AssistanceProtocolTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aac2eb",
  null
  
)

export default component.exports